<script>
export default {
    props: {
        //自定义设备查询组件
        devQueryComponent: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.valueInfo = newValue;
            },
            deep: true,
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: false
        }
    },
    data() {
        return {
            valueInfo: this.value,
            component: this.devQueryComponent
        };
    },
    created() {
        // 初始化数据
        this.dealData();
    },
    methods: {
        dealData() {
            // 注册回调事件
            let events = {};
            var _this = this;
            //子组件的input事件
            events.input = event => {
                if (event !== undefined) {
                    this.valueInfo = event;
                    //触发父组件的input事件，将值传给父组件
                    _this.$emit('input', this.valueInfo);
                }
            };
            this.$set(this.component, 'on', events);
        }
    },
    render: function(createElement) {
        return createElement(
            'el-form-item',
            {
                props: {
                    prop: this.component.keyName,
                    label: this.component.label
                }
            },
            [
                createElement(this.component.type, {
                    key: this.component.keyName,
                    props: this.component.props,
                    on: this.component.on,
                    ref: this.component.keyName
                })
            ],
            this.component.label
        );
    }
};
</script>
